import React, { ComponentProps } from 'react';

import { Product } from 'models/product';
import { SearchResult } from 'models/search';
import { useAppContext } from 'store/appContext';

import ApproximatedConvertedPrice from '../ApproximatedConvertedPrice/ApproximatedConvertedPrice';

import { getPrices } from './logic/getPrices';
import { BeforeReductionPrice } from './view/BeforeReductionPrice';
import { CurrentPrice } from './view/CurrentPrice';

export const Prices: React.FC<{
  product: Product | SearchResult;
  style: {
    beforeReductionPrice: ComponentProps<typeof BeforeReductionPrice>['style'];
    currentPrice: ComponentProps<typeof CurrentPrice>['style'];
  };
}> = ({ style, product }) => {
  const { approxCurrencyCode, currencySymbol } = useAppContext();
  const {
    formattedPriceApprox,
    formattedPriceReducedAfterTax,
    formattedPriceBaseAfterTax,
    reductionPercentage,
  } = getPrices({ approxCurrencyCode, currencySymbol, product });

  return (
    <div className="priceWrapper">
      <BeforeReductionPrice
        formattedPriceAfterReduction={formattedPriceBaseAfterTax}
        reductionPercentage={reductionPercentage}
        style={style.beforeReductionPrice}
      />

      <CurrentPrice
        formattedCurrentPrice={formattedPriceReducedAfterTax}
        reductionPercentage={reductionPercentage}
        style={style.currentPrice}
      />

      {formattedPriceApprox && (
        <>
          <ApproximatedConvertedPrice formattedPrice={formattedPriceApprox} />
        </>
      )}
      <style jsx>
        {`
          .priceWrapper {
            margin-top: 12px;
          }
        `}
      </style>
    </div>
  );
};
